import { createAuthenticator, WoltAuthenticationService } from '@creditornot/wolt-auth';

import { storage } from './storage';

export const authenticator = createAuthenticator({
  authService: new WoltAuthenticationService({ serviceUrl: process.env.AUTH_API_URI }),
  storage,
});
